import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, Link } from '@domain-group/suit-theme'

import type { UseOrderItemPayload } from '@hooks/useOrderItem'

import EnabledPermission from '@components/EnabledPermission'
import { getCampaignType } from '@functions/campaign'

type OrderItemTaskProps = {
  boxProps?: object,
  orderItemPayload: UseOrderItemPayload,
}

const OrderItemTask = (props: OrderItemTaskProps) => {
  const {
    boxProps,
    orderItemPayload: {
      campaign,
      callbacks: {
        manageTasks,
      },
      filteredOrderItemTasks,
    },
  } = props

  const taskCount = filteredOrderItemTasks.length

  return (
    <Box
      alignItems="center"
      backgroundColor="white"
      borderRadius={5}
      border="1px dashed"
      borderColor="lineColor"
      justifyContent="space-between"
      padding="large"
      {...boxProps}
    >
      <Link onClick={() => manageTasks()} textProps={{ color: 'bodyFontLightColor', fontSize: 'xsmall' }}>
        View ({taskCount}) {taskCount === 1 ? 'Task' : 'Tasks'}
      </Link>

      <EnabledPermission
        campaignType={getCampaignType(campaign)}
        permissionKey="campaign.tasks.manage"
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => manageTasks()}
          size="small"
          width="auto"
        >
          Add Task
        </Button>
      </EnabledPermission>
    </Box>
  )
}

export default OrderItemTask
